import classNames from 'classnames';

import './field.scss';

export enum FieldState {
  INVALID = 'invalid',
  FOCUS = 'focus',
  FOCUS_KEYBOARD = 'focusKeyboard',
  DISABLED = 'disabled',
}

export enum FieldType {
  CHECKBOX = 'checkbox',
  RADIO = 'radio',
  UNIT = 'unit',
  NUMBER = 'number',
  TEXT = 'text',
  EMAIL = 'email',
  PASSWORD = 'password',
  SEARCH = 'search',
  DATE = 'date',
  TEXTAREA = 'textarea',
  SELECT = 'select',
}

export interface BaseFieldProps {
  id: string;
  description?: string;
  errorMessage?: string;
  state?: FieldState;
  extraClasses?: string;
  children?: React.ReactNode;
}

const BaseField = ({
  id,
  description,
  errorMessage,
  state,
  extraClasses = '',
  children,
}: BaseFieldProps & { children: React.ReactNode }) => {
  return (
    <div
      className={classNames({
        'a-form-field': true,
        [extraClasses]: extraClasses,
      })}
    >
      {children}

      {(description || errorMessage) && (
        <div
          className="a-form-field__message u-text-tiny"
          id={`${id}-message`}
          role="alert"
        >
          {state === FieldState.INVALID && errorMessage && (
            <span
              className="u-color-error"
              aria-live="assertive"
              aria-atomic="true"
            >
              {errorMessage}
            </span>
          )}

          {description && <span>{description}</span>}
        </div>
      )}
    </div>
  );
};

export default BaseField;
